import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectStation = (state: AppState) => state.station;

export const getStations = () => createSelector(selectStation, (state) => state.stations);
export const getStationsTotal = () => createSelector(selectStation, (state) => state.stationsTotal);
export const getFilter = () => createSelector(selectStation, (state) => state.filter);

export const getStationRawDataFilter = () => createSelector(selectStation, (state) => state.station_raw_data_filter);
export const getStationRawData = () => createSelector(selectStation, (state) => state.station_raw_data);

export const getStationsConnections = () => createSelector(selectStation, (state) => state.stations_connections);

export const getStationsIssuesFilter = () => createSelector(selectStation, (state) => state.stations_issues_filter);
export const selectStationsIssues = () => createSelector(selectStation, (state) => state.stations_issues);
export const selectTotaStationsIssuesCount = () =>
  createSelector(selectStation, (state) => state.total_stations_issues);
